module.exports = __webpack_public_path__ + "static/img/Kayle-Gerreyn.645fa27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kayle-Gerreyn.jpg
// module id = lw0O
// module chunks = 0